import React from 'react';

const VideoForecast = (props) => {
  console.log(props); // eslint-disable-line no-console

  return (
    <div className="weather-component video-forecast">
      Hello, I am the weather page Video Forecast component...
    </div>
  );
};

export default VideoForecast;
